// extracted by mini-css-extract-plugin
export var root = "BurgerButton-module--root--3tdW_";
export var active = "BurgerButton-module--active--1mnQX";
export var bar = "BurgerButton-module--bar--3CUU5";
export var inverted = "BurgerButton-module--inverted--CxVw8";